import { combineReducers } from 'redux';

import { Reducer } from '../../../types';
import {
  authInitSuccess,
  logInSuccess,
  logOut,
  refreshSuccess,
} from '../actions';
import { AuthAction, TokenSet } from '../types';

type ReducerOf<T extends keyof TokenSet> = Reducer<TokenSet, AuthAction, T>;

const access: ReducerOf<'access'> = (state = null, action) => {
  switch (action.type) {
    case authInitSuccess.type:
    case logInSuccess.type:
    case refreshSuccess.type:
      return action.payload.access || null;

    case logOut.type:
      return null;

    default:
      return state;
  }
};

const refresh: ReducerOf<'refresh'> = (state = null, action) => {
  switch (action.type) {
    case authInitSuccess.type:
    case logInSuccess.type:
    case refreshSuccess.type:
      return action.payload.refresh || null;

    case logOut.type:
      return null;

    default:
      return state;
  }
};

const expireDate: ReducerOf<'expireDate'> = (state = null, action) => {
  switch (action.type) {
    case authInitSuccess.type:
    case logInSuccess.type:
    case refreshSuccess.type:
      return action.payload.expireDate || null;

    case logOut.type:
      return null;

    default:
      return state;
  }
};

export default combineReducers<TokenSet>({
  access,
  refresh,
  expireDate,
});
